import { createContext, useContext, useState, useEffect } from 'react';

const FlashCardGameFiltersContext = createContext();

const defaultFilters = {
  general: false,
  geography: false,
  jokes: false,
  math: false,
  music: false,
  periodicElements: false,
  person: false,
  usPresidents: false,
  usStates: false,
  vocabulary: false,
}

export const FlashCardGameFiltersProvider = ({ children }) => {
  const savedFilters = JSON.parse(localStorage.getItem('flashCardGameFilters'));
  const savedNumberOfFlashCards = localStorage.getItem('numberOfFlashCards');
  const [filters, setFilters] = useState(savedFilters || defaultFilters);
  const [allChecked, setAllChecked] = useState(false);  
  const [numberOfFlashCards, setNumberOfFlashCards] = useState(savedNumberOfFlashCards || 50);
  const [updateFlashCards, setUpdateFlashCards] = useState(1);

  useEffect(() => {
    const allTrue = Object.values(filters).every(Boolean);
    if (allTrue) setAllChecked(true);
    else setAllChecked(false);
  }, [filters]);

  useEffect(() => {
    localStorage.setItem('flashCardGameFilters', JSON.stringify(filters));
    localStorage.setItem('numberOfFlashCards', numberOfFlashCards);
  }, [filters, numberOfFlashCards]);

  return (
    <FlashCardGameFiltersContext.Provider value={{ filters, setFilters, allChecked, numberOfFlashCards, setNumberOfFlashCards, updateFlashCards, setUpdateFlashCards }}>
      {children}
    </FlashCardGameFiltersContext.Provider>
  );
};

export const useFilters = () => useContext(FlashCardGameFiltersContext);
